// extracted by mini-css-extract-plugin
module.exports = {"social-share-buttons":"_2Ndgq","socialShareButtons":"_2Ndgq","social-share-group":"_2JsGy","socialShareGroup":"_2JsGy","social-share-button":"_1ORmd","socialShareButton":"_1ORmd"};